module.exports = __webpack_public_path__ + "img/bg7-12.8b49b87b.png";